module.exports = __webpack_public_path__ + "img/logo-header.ee5a4a37.png";